// extracted by mini-css-extract-plugin
export default {"formChild":"FormComp_formChild__EcL0h"};